{
    "CX_Score_Licences_None": "Nessuno",
    "CX_Score_Licences_CXSScore": "Solo punteggio CX",
    "CX_Score_Licences_CXSAgent": "Agente CXS",
    "CX_Score_Licences_CXSManager": "Responsabile CXS",
    "CX_Score_Agent_Error": "Per un abbonamento {} è necessario un agente",
    "NAME": "CXScoreLanguage"
}